import { getWindow } from "./getWindow";
import type { DataLayerItemPageTrack } from "./types";

type UserSession = {
    newUser: string;
    pageCount: string;
};

const newUserStorageKey = "wcom_new_user";
const pageCountStorageKey = "wcom_page_count";
const consentStorageKey = "uc_tcf";
const notset = "notset";

export const getUserSession = (): UserSession => {
    const window = getWindow();

    try {
        return {
            newUser:
                window?.sessionStorage.getItem(newUserStorageKey) ?? notset,
            pageCount:
                window?.sessionStorage.getItem(pageCountStorageKey) ?? notset,
        };
    } catch {
        return { newUser: notset, pageCount: notset };
    }
};

export const initializeUserSession = (window: Window): void => {
    try {
        if (window.localStorage.getItem(consentStorageKey) === null) {
            window.sessionStorage.setItem(newUserStorageKey, "true");
        } else if (window.sessionStorage.getItem(newUserStorageKey) === null) {
            window.sessionStorage.setItem(newUserStorageKey, "false");
        }
    } catch {
        // Do nothing if SessionStorage is inaccessible
    }
};

export const setUserSession = (
    window: Window,
    pageTrack: DataLayerItemPageTrack
): void => {
    let newUser: boolean | undefined;
    let pageCount: number | undefined;

    try {
        const storedNewUser = window.sessionStorage.getItem(newUserStorageKey);
        newUser =
            storedNewUser === null
                ? window.localStorage.getItem(consentStorageKey) === null
                : storedNewUser === "true";
        const storedPageCount = parseInt(
            window.sessionStorage.getItem(pageCountStorageKey) ?? "-1",
            10
        );
        pageCount = (Number.isNaN(storedPageCount) ? -1 : storedPageCount) + 1;

        window.sessionStorage.setItem(newUserStorageKey, String(newUser));
        window.sessionStorage.setItem(pageCountStorageKey, String(pageCount));
    } catch {
        // newUser and pageCount will stay undefined if SessionStorage is not accessible
    }

    pageTrack.new_user = newUser;
    pageTrack.page_count = pageCount;

    window.adHandler?.service?.setTargeting(
        "new_user",
        newUser?.toString() ?? notset
    );
    window.adHandler?.service?.setTargeting(
        "page_count",
        pageCount?.toString() ?? notset
    );
};
